import { ADD_USER, CHANGE_USER_STATUS, DELETE_USER, EDIT_USER, RESET_PASSWORD, SET_USERS, SET_USERS_SEARCH_VALUE, } from "../constants";
import { convertUserFromServer } from "../utils/user";
const reducer = (state, action) => {
    switch (action.type) {
        case SET_USERS: {
            const serverUsers = action.payload;
            const users = serverUsers.map(convertUserFromServer);
            return Object.assign(Object.assign({}, state), { users });
        }
        case ADD_USER: {
            const serverUser = action.payload;
            const user = convertUserFromServer(serverUser);
            return Object.assign(Object.assign({}, state), { users: [...state.users, user] });
        }
        case EDIT_USER: {
            const editedServerUser = action.payload;
            const editedUser = convertUserFromServer(editedServerUser);
            const users = state.users.map((user) => user.id === editedUser.id ? editedUser : user);
            return Object.assign(Object.assign({}, state), { users });
        }
        case CHANGE_USER_STATUS: {
            const { isActive, userId } = action.payload;
            const users = state.users.map((user) => user.id === userId ? Object.assign(Object.assign({}, user), { is_active: isActive }) : user);
            return Object.assign(Object.assign({}, state), { users });
        }
        case RESET_PASSWORD: {
            const userId = action.payload;
            const users = state.users.map((user) => user.id === userId ? Object.assign(Object.assign({}, user), { has_password: false }) : user);
            return Object.assign(Object.assign({}, state), { users });
        }
        case DELETE_USER: {
            const userId = action.payload;
            const users = state.users.filter((user) => user.id !== userId);
            return Object.assign(Object.assign({}, state), { users });
        }
        case SET_USERS_SEARCH_VALUE: {
            const usersSearchValue = action.payload;
            return Object.assign(Object.assign({}, state), { usersSearchValue });
        }
        default:
            return state;
    }
};
export { reducer };
